module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-group-listing"
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "collapsed",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = true
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [(_vm.unitCount > 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa alla " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e(), _vm._v(" "), (_vm.unitCount === 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down-white"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.expanded) ? _c('div', {
    staticClass: "expanded"
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = false
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Stäng")]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.groupedUnits), function(group, index) {
    return _c('div', {
      key: group.key,
      staticClass: "animate-pool-list-item",
      class: {
        odd: index % 2
      }
    }, [_c('AccomodationsListUnitsList', {
      attrs: {
        "units": group.units,
        "grouping": group.title
      }
    })], 1)
  }), 0)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4713d31f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/List/AccomodationsListUnitsGroup.vue
// module id = 982
// module chunks = 0